import { UiComponents } from "@simulanisindia/ui";

const { Header: UIHeader } = UiComponents;

const Header = () => {

  return (
    <>
      <UIHeader showSearch={false} />
    </>
  );
};

export default Header;
